module.exports = __webpack_public_path__ + "static/Roboto-Regular-8169e1a170280556f069ca104db7a405.woff2";